import React from 'react';
import { Link } from 'react-router-dom';

import logoLight from 'assets/images/CorporateLanding/logo-light.svg';
import { IS_PRODUCTION_ENV } from 'constants/env.constants';
import { SecurityPageTarget } from 'components/SecurityPage/enums/SecurityPageTarget.enum';

export default function Footer() {
  return (
    <footer className="footer footer-corp">
      <div className="container">
        <div className="footer-row">
          <div className="footer-logo">
            <strong className="logo">
              <a href="#top">
                <img src={logoLight} alt="logo" />
              </a>
            </strong>
          </div>
          <ul className="footer-list">
            <li className="footer-list__title">myProducts</li>
            <li>
              <Link to="/financial-eor-compliance">Back-Office Solutions</Link>
            </li>
            <li>
              <Link to="/jobs-talent-aquisition">TA Marketplace</Link>
            </li>
            <li>
              <Link to="/hr-staffing-solutions">Corporate TA</Link>
            </li>
          </ul>
          <ul className="footer-list">
            <li className="footer-list__title">Company</li>
            <li>
              <Link
                to={`/information-security?target=${SecurityPageTarget.Corporate}`}
              >
                myBasePay Security
              </Link>
            </li>
            <li>
              <Link to="/about-us">About Us</Link>
            </li>

            {/* Blog is available only on production env */}
            {IS_PRODUCTION_ENV && (
              <>
                <li>
                  <a href={`${window.location.origin}/blog`}>myBlog</a>
                </li>

                <li>
                  <a href={`${window.location.origin}/blog/podcasts`}>
                    myPodcast
                  </a>
                </li>
              </>
            )}

            <li>
              <a
                href="https://secure6.saashr.com/ta/6172234.clock"
                target="_blank"
                rel="noreferrer"
              >
                Worker Login
              </a>
            </li>
          </ul>
          <div></div>
          <ul className="footer-social">
            <li>
              <a href="https://www.linkedin.com/company/my-basepay/">
                <span className="icon icon-linkedin" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/mybasepay">
                <span className="icon icon-twitter" />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCbOebKGBdYmSdfuxhFnKbqA/">
                <span className="icon icon-youtube" />
              </a>
            </li>
          </ul>
          <div className="footer-copyright">&copy; 2021 myBasePay LLC</div>
        </div>
      </div>
    </footer>
  );
}
